import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import SportEmoji from "@/components/SportEmojis";
import type { SportType } from "@/types";
import { useLocalAppState } from "@/contexts/LocalAppStateContext";

const sports: Array<{ id: SportType; label: string }> = [
  { id: "soccer", label: "Soccer" },
  { id: "nba", label: "NBA" },
  { id: "nfl", label: "NFL" },
  { id: "mlb", label: "MLB" },
  { id: "nhl", label: "NHL" },
];

export default function Onboarding() {
  const [selected, setSelected] = useState<SportType[]>([]);
  const { completeOnboarding, skipOnboarding } = useLocalAppState();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-slate-950 text-white">
      <Header />
      <main id="main-content" className="mx-auto max-w-xl px-5 py-10">
        <p className="text-sm font-semibold text-indigo-300">
          Private by default
        </p>
        <h1 className="mt-2 text-4xl font-bold tracking-tight">
          Pick the sports you follow
        </h1>
        <p className="mt-4 text-slate-400">
          This stays on your device. You can skip and change it later.
        </p>
        <div className="mt-8 grid grid-cols-2 gap-3">
          {sports.map((sport) => {
            const active = selected.includes(sport.id);
            return (
              <button
                type="button"
                aria-pressed={active}
                key={sport.id}
                onClick={() =>
                  setSelected((current) =>
                    active
                      ? current.filter((id) => id !== sport.id)
                      : [...current, sport.id],
                  )
                }
                className={`flex min-h-16 items-center gap-3 rounded-xl border px-4 text-left font-semibold focus-visible:outline focus-visible:outline-2 focus-visible:outline-indigo-300 ${active ? "border-indigo-400 bg-indigo-500/20 text-indigo-100" : "border-white/10 bg-slate-900 text-slate-200"}`}
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-slate-950/70 ring-1 ring-white/10">
                  <SportEmoji sportType={sport.id} size="medium" />
                </span>
                <span>{sport.label}</span>
              </button>
            );
          })}
        </div>
        <button
          type="button"
          disabled={!selected.length}
          onClick={() => {
            completeOnboarding(selected);
            navigate("/");
          }}
          className="mt-8 min-h-12 w-full rounded-xl bg-indigo-500 px-5 font-bold text-white disabled:cursor-not-allowed disabled:opacity-40"
        >
          Continue
        </button>
        <button
          type="button"
          onClick={() => {
            skipOnboarding();
            navigate("/");
          }}
          className="mt-3 min-h-11 w-full rounded-xl text-sm text-slate-400 hover:text-white"
        >
          Skip for now
        </button>
      </main>
    </div>
  );
}
